import { Fileira } from './fileira';
import { Cliente } from './cliente';
import { VendaObs } from './venda-obs';
import { TagGi } from './tag-gi';
import { Voucher } from './voucher';
import { VendaFormaPag } from './venda-forma-pag';
import { VendaSeguro } from './venda-seguro';
import { VendaResposta } from './venda-resposta';
import * as internal from 'assert';
import { VendaEntrega } from './venda-entrega';
import { EtapaDoPedido, OrigemGI } from './enum';

export class ResumoPedido {
  idCupom: string;
  data: Date;
  valorVenda: number;
  frete: number;
  valorTotal: number;
  // formaPagamento: string;
  // condicaoPagamento: string;
  enderecoEntrega: string;
  responsavelEntrega: string;
  telefoneEntrega: string;
  vendedor: string;
  idVendedor: number;
  cliente: string;
  clienteFantasia: string;
  vendaDireta: boolean;
  idClienteFaturamento: number;
  da: number;
  valorDa: number;

  tipoFrete: string;
  transportadora: string;

  itens: VendaItemResumo[];
  fileiras: Fileira[];
  clienteFaturamento: Cliente;

  celularCliente: string;
  emailCliente: string;

  observacao: string;

  notaSerie: string;
  notaNumero: string;

  volume: number;
  dimensao: string;
  peso: number;
  potencia: number;
  valorServico: number;
  integrador?: any;

  observacoes: VendaObs[];
  tags: TagGi[];

  numeroDeSerie: string;
  codFiname: string;

  codErpIntegrador: string;
  previsaoEntrega: Date;

  voucher: Voucher;

  fornecedor: string;

  dispEstoque: boolean;
  dataDispEstoque?: Date;
  formasPagamento: VendaFormaPag[];

  codErp: number;
  tipoLocalizacao: string;

  seguros: VendaSeguro[];

  respostas: VendaResposta[];

  idFornecedor: number;

  liderVendedor: string;

  enderecoDeEntrega: VendaEntrega;

  custoProdutos: number;

  orcamento: boolean;

  idEtapa: number;

  textoEtapa: string;

  ordemEtapa: EtapaDoPedido;

  status: number;

  expirado: boolean;

  substituicao: boolean;

  tipoCIF: string;

  fornecedorSugerido: string;
  idFornecedorSugerido: number;
  cidadeCD: string;
  possuiTermoAceitePendente: boolean;

  idCliente: number;

  origemGI: OrigemGI;

  ipi: number;

  formasPagamentoDescricao: string;
  condicoesPagamentoDescricao: string;

  multiFormaPagamento: boolean;

  modalidadeFrete: string;

  taxaCondicaoPagamento: number;
  valorArredondamento: number;

  // virtuais
  possuiAnexos: boolean;
  possuiMensagens: boolean;
  possuiNotasFiscais: boolean;
}

export class VendaItemResumo {
  codBarra: string;
  descricao: string;
  pUnitario: number;
  qt: number;
  vTotal: number;
  familia: number;
  endereco: string;
  desconto: number;
  vTotalBruto: number;
  codErp: string;
  obs: string;
  composicao: any[];
}
